import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Briefcase, Menu, X } from 'lucide-react';
import { NAV_ITEMS } from '@utils/constants';

const Navigation = ({ 
  isMenuOpen, 
  setIsMenuOpen, 
  currency, 
  setCurrency, 
  scrollToSection,
  openBooking,
  isLoggedIn 
}) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-2"
          >
            <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-600/20">
              <Briefcase className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold bg-gradient-to-r from-indigo-900 to-violet-900 bg-clip-text text-transparent">
              Placement Point
            </span>
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-slate-600 hover:text-indigo-600 font-medium transition-colors relative group"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-indigo-600 transition-all group-hover:w-full" />
              </button>
            ))}

            {/* Currency Toggle */}
            <div className="flex items-center gap-2 bg-slate-100 rounded-full p-1">
              <button
                onClick={() => setCurrency('NGN')}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
                  currency === 'NGN' 
                    ? 'bg-white text-indigo-600 shadow-sm' 
                    : 'text-slate-500'
                }`}
              >
                ₦
              </button>
              <button
                onClick={() => setCurrency('USD')}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
                  currency === 'USD' 
                    ? 'bg-white text-indigo-600 shadow-sm' 
                    : 'text-slate-500'
                }`}
              >
                $
              </button>
            </div>

            {/* CTA Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => openBooking()}
              className="bg-indigo-600 text-white px-6 py-2.5 rounded-full font-semibold shadow-lg shadow-indigo-600/25 hover:shadow-indigo-600/40 transition-shadow"
            >
              {isLoggedIn ? 'Go to Dashboard' : 'Get Started'}
            </motion.button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-slate-100"
          >
            <div className="px-4 py-6 space-y-4">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left text-slate-600 font-medium py-2"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => openBooking()}
                className="w-full bg-indigo-600 text-white py-3 rounded-xl font-semibold mt-4"
              >
                {isLoggedIn ? 'Go to Dashboard' : 'Get Started Now'}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navigation;
